module.exports = __webpack_public_path__ + "static/media/nuvemshop7.12fc56f7.png";